module.exports = __webpack_public_path__ + "static/media/life-bespoke.de4a4e57.jpg";